export default __webpack_public_path__ + "static/media/gallery_12.b68aed8b.jpg";